// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Libraries
import cuid from 'cuid'

// Components
import BSwitch from 'ui/blocks/Switch'

// Shared

/**
 * Switch, like a checkbox, but fancier.
 *
 * @example
 *   <Switch checked onChange={this.handleChange} />
 */

export default class Switch extends Component {
  static displayName = 'Switch'

  static propTypes = {
    id: PropTypes.string,
    disabled: PropTypes.bool,
    field: PropTypes.object,
    label: PropTypes.any,
    description: PropTypes.any,
    inverted: PropTypes.bool,
    withActiveEffect: PropTypes.bool,
    block: PropTypes.bool,
    relative: PropTypes.bool,
    mirror: PropTypes.bool
  }

  static defaultProps = {
    withActiveEffect: true
  }

  handleChange = () => {
    const { onChange, value } = this.props.field

    onChange(!value)
  }

  render () {
    const { disabled, description, label, inverted, withActiveEffect, block, relative, ...otherProps } = this.props
    const field = this.props.field || { value: false, onChange: () => {} }
    const onChange = disabled ? undefined : this.handleChange
    const id = this.props.id || cuid()

    let checked = field.value || false

    if (inverted) {
      checked = !checked
    }

    return (
      <BSwitch {...otherProps}>
        <BSwitch.Input id={id} type="checkbox" checked={checked} onChange={onChange} readOnly={disabled} />
        <BSwitch.Toggle
          data-tid={`Switch ${label}`}
          className="switch"
          htmlFor={id}
          checked={checked}
          disabled={disabled}
          readOnly={disabled}
          withActiveEffect={withActiveEffect}
          block={block}
          relative={relative}
        />
        {label && <BSwitch.Label onClick={onChange}>{label}</BSwitch.Label>}
        {description && <BSwitch.Description>{description}</BSwitch.Description>}
      </BSwitch>
    )
  }
}
